import React from 'react';

import { spreadAndtransformDefaultValues } from '@common/components/forms';
import { useCurrentRoute } from '@common/hooks';
import { HospitalModel, IIvlsDeviceModel, OrganizationListingModel } from '@common/models';
import { LocationDetailUsersList } from '@hospital/views/shared/locations';
import { LocationScheduleTemplateDetail } from '@hospital/views/shared/schedule';
import { observer } from 'mobx-react';
import { FormProvider, useForm } from 'react-hook-form';
import { LocationDetailStaticInfo } from './LocationDetailStaticInfo';
import { LocationDiagnosticDetail } from './LocationDiagnosticDetail';
import { LocationFlagDetail } from './LocationFlagDetail';
import { LocationHospitalDetail } from './LocationHospitalDetail';
import { LocationHoursDetail } from './LocationHoursDetail';
import { IHospitalHoursGroup } from './LocationStore';

interface IProps {
    hospital: HospitalModel
    hospitalHoursGroup: IHospitalHoursGroup
    pricingTierOrganization: OrganizationListingModel | undefined;
    onUpdateHospital: (data: HospitalModel) => void
    clearHospitalHoursConfirmation: () => void
    setHospitalHoursChangesConfirmed: () => void
    refreshIvlsDevices: (hospitalId: number) => void;
    ivlsDevices: IIvlsDeviceModel[] | undefined
}

export const LocationDetailForm = observer(({ hospital, onUpdateHospital, setHospitalHoursChangesConfirmed, hospitalHoursGroup, clearHospitalHoursConfirmation, pricingTierOrganization, refreshIvlsDevices, ivlsDevices }: IProps) => {
    const currentRoute = useCurrentRoute();
    const isAdmin = currentRoute?.pathname.toLowerCase().startsWith("/admin");
    const userProfileBaseUrl = isAdmin ? "../../users/" : "../users/";

    const methods = useForm<Omit<HospitalModel, "defaultScheduleTemplate">>({ //<- omit defaultScheduleTemplate because it causes a circular reference.
        defaultValues: spreadAndtransformDefaultValues(hospital), shouldFocusError: true
    });

    return (
        <FormProvider {...methods} >
            <div className="d-xl-flex flex-fill flex-row">
                <div className="d-flex flex-column flex-grow-1">
                    <LocationDetailStaticInfo hospital={hospital} className="mb-3 me-0 me-xl-3" />
                    <LocationHospitalDetail hospital={hospital} className="mb-3  me-0 me-xl-3" onUpdateHospital={onUpdateHospital} pricingTierOrganization={pricingTierOrganization} />
                    <LocationDiagnosticDetail hospital={hospital} className="mb-3  me-0 me-xl-3" onUpdateHospital={onUpdateHospital} refreshIvlsDevices={refreshIvlsDevices} ivlsDevices={ivlsDevices} />
                    <LocationHoursDetail className="mb-3 me-0 me-xl-3" onUpdateHospital={onUpdateHospital} {...{ setHospitalHoursChangesConfirmed, hospitalHoursGroup, clearHospitalHoursConfirmation }} />
                </div>
                <div className="d-flex flex-column flex-grow-1">
                    <LocationFlagDetail hospital={hospital} onUpdateHospital={onUpdateHospital} className="mb-3" />
                    <LocationDetailUsersList className="mb-3 flex-grow-1" hospital={hospital} userProfileBaseUrl={userProfileBaseUrl} />
                </div>
            </div>
            <div className="d-flex flex-fill flex-row">
                <div className="d-flex flex-column flex-grow-1">
                    <LocationScheduleTemplateDetail hospital={hospital} className="" />
                </div>
            </div>
        </FormProvider>
    )
});

export default LocationDetailForm;
